import Select from 'react-select'
import axios from 'axios'
import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate, useLocation} from 'react-router-dom'
import {KTSVG, useDebounce} from '../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'

import {
  DeleteWhitelableUser,
  GetAllWhiteLabel,
  getWhiteLableList,
  UpdateStatus,
} from './WhiteLabelSlice/WhiteLabelSlice'
import CreateWhiteLabel from './Modal/CreateWhiteLabelPopup'
import {
  ProfileDetailData,
  WhiteLabelProfileData,
} from '../../../Redux/AdminPanel/ProfileDetailsSlice'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {StatusColor, verfiyColor} from '../../../Utils/Constant/ArrayOfSideNav'
import NodataYet from '../../../Components/NodataYet'
import {DropdownButton, Dropdown} from 'react-bootstrap'
import {Check} from 'react-bootstrap-icons'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

const WhiteLabelList = () => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const navigate = useNavigate()
  const param = useLocation()
  const dispatch = useDispatch()
  const [createWhitelabelPopup, setCreateWhitelabelPopup] = useState(false)
  const API_URL = ENV().REACT_APP_API_URL
  const [tags, setTags] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [checkList, setCheckList] = useState<any>([])

  const [apply, setApply] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [page, setPage] = useState<any>({
    page: 1,
    size: 10,
    search: '',
  })
  const [status, setStatus] = useState<any>('')
  /////////USE SELECTOR//////////////////////////////////////
  const whiteLabelAccountList = useSelector(getWhiteLableList)

  const debouncedSearchTerm = useDebounce(page?.search, 500)

  useEffect(() => {
    const filterData = {
      page: page.page,
      size: page.size,

      status: status.value,
      search: page.search,
    }
    if (page.page || page.size) {
      dispatch(GetAllWhiteLabel({...filterData}))
    }
  }, [debouncedSearchTerm, page, apply])

  const handleSelect = (id: any) => {
    setOpen(true)
    setDeleteIds([id])
  }

  //IF get confirmation from popup it will delete
  useEffect(() => {
    if (confirm == true) {
      dispatch(DeleteWhitelableUser({id: deleteIds[0]}))
      setCheckList([])
      setConfirm(false)
    }
  }, [confirm])

  const handleDeleteAll = () => {
    setOpen(true)
    setDeleteIds(checkList)
  }
  const DeleteConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        page={page}
        show={open}
        handleClose={() => setOpen(false)}
        checklist={() => setCheckList([])}
        Message={'Are you sure, you want to delete this whitelabel?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )
  const handleExport = () => {
    // Extracting values and creating a new object
    const filterData = {
      page: page.page,
      size: page.size,

      status: status.value,
      search: page.search,
    }
    axios
      .get(`${API_URL}admin/listWhiteLabelUsers`, {
        params: {
          ...filterData,
          export: true,
          exportArr: checkList?.join(','),
        },
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res: any) => {
        window.open(`${API_DOMAIN}${res.data.data.downloadurl}`, '_self')
        setCheckList([])
      })
  }

  const CreateWhiteLabelUser = useMemo(
    () => (
      <CreateWhiteLabel
        show={createWhitelabelPopup}
        handleClose={() => setCreateWhitelabelPopup(false)}
      />
    ),
    [createWhitelabelPopup]
  )
  return (
    <>
      {DeleteConfirmation}
      {CreateWhiteLabelUser}
      <div className={`sub-accountstable card `}>
        <div className='card-header border-0 pt-5'>
          <div className='card-toolbar'>
            <div className='d-flex align-items-center position-relative m-0'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-1 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control form-control-solid w-250px ps-14'
                placeholder='Search user'
                value={page?.search}
                onChange={(e) => setPage({...page, search: e.target.value, page: 1, size: 10})}
              />
            </div>
            <div
              className='filter_parent'
              onMouseEnter={() => setFilterOpen(true)}
              onMouseLeave={() => setFilterOpen(false)}
            >
              <button
                className={`btn btn-light-primary ms-3 me-3 filter_btn ${
                  filterOpen && 'show menu-dropdown'
                } `}
                data-kt-menu-placement='bottom-end'
              >
                <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
                Filter
              </button>

              <div
                className={`menu menu-sub menu-sub-dropdown w-250px w-md-300px ${
                  filterOpen && 'show filtermenu'
                }`}
              >
                <div className='px-7 py-5'>
                  <div className='mb-10'>
                    <label className='form-label fw-bold'>Status:</label>

                    <div>
                      <Select
                        value={status}
                        onChange={(e: any) => setStatus(e)}
                        className='form-select form-select-solid fw-bolder'
                        placeholder={'Select status'}
                        options={[
                          {value: 'active', label: 'Active'},
                          {value: 'inactive', label: 'Inactive'},

                          {value: 'suspended', label: 'Suspended'},
                        ]}
                      />
                      {/* <select
                        value={page?.status}
                        name='status'
                        onChange={(e: any) => setPage({...page, status: e.target.value})}
                        className='form-select form-select-solid fw-bolder'
                      >
                        <option value=''>Select Status</option>
                        <option value='active'> Active </option>
                        <option value='inactive'> Inactive </option>
                        <option value='suspended'> Suspended </option>
                      </select> */}
                    </div>
                  </div>

                  <div className='d-flex justify-content-end'>
                    <button
                      type='reset'
                      className='btn btn-sm btn-white btn-active-light-primary me-2'
                      onClick={() => {
                        setPage({
                          page: 1,
                          size: 10,
                          search: '',
                          status: '',
                        })
                        setTags([])
                        setStatus('')
                      }}
                    >
                      Reset
                    </button>

                    <button
                      type='submit'
                      className='btn btn-sm btn-primary'
                      data-kt-menu-dismiss='true'
                      onClick={() => {
                        setApply(!apply)
                        setFilterOpen(false)
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* AuthenticateUser('export-user') || */}
            {true && (
              <button onClick={handleExport} type='button' className='btn btn-light-primary me-3'>
                <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                Export
              </button>
            )}

            {AuthenticateUser('create-whitelabel') && (
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => setCreateWhitelabelPopup(true)}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                Add WhiteLabel
              </button>
            )}
          </div>
        </div>
        {whiteLabelAccountList?.items?.length > 0 ? (
          <>
            {' '}
            <div className='card-body py-3'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bolder text-muted'>
                      <th className='min-w-150px'>USER</th>
                      <th className='min-w-140px'>COMPANY</th>
                      <th className='min-w-140px'>SUB DOMAIN</th>
                      <th className='min-w-140px'>PHONE</th>
                      <th className='min-w-140px'>Verified</th>
                      <th className='min-w-140px'>STATUS</th>
                      <th className='min-w-150px'>LAST LOGIN</th>
                      <th className='min-w-150px'>LAST SEND</th>
                      <th className='min-w-150px'>PAYMENT TYPE</th>
                      <th className='min-w-150px'>CREATED ON</th>
                      <th className='min-w-150px'>Total PURCHED</th>
                      <th className='min-w-150px'>TOTAL SPENT</th>
                      <th className='min-w-150px'>BALANCE</th>
                      {(AuthenticateUser('delete-whitelabel') ||
                        AuthenticateUser('edit-whitelabel')) && (
                        <th className='min-w-100px text-end'>ACTIONS</th>
                      )}
                    </tr>
                  </thead>
                  {whiteLabelAccountList?.items?.map((key: any, i: number) => {
                    const data = key?.user
                    return (
                      <tr key={i}>
                        <td>
                          <div
                            onClick={() => {
                              if (AuthenticateUser('edit-whitelabel')) {
                                dispatch(WhiteLabelProfileData(key?._id))
                                navigate(`/whiteLabel-profile`)
                              }
                            }}
                            className='d-flex align-items-center'
                          >
                            <div className='symbol symbol-45px me-5 cursor-pointer'>
                              {key?.whiteLabelLogo !== '' ? (
                                <img src={key?.whiteLabelLogo} alt='' />
                              ) : (
                                <span className='circle1'>{`${
                                  data?.firstName !== undefined && data?.firstName !== ''
                                    ? data?.firstName?.split('')[0]?.toUpperCase()
                                    : ''
                                }${
                                  data?.lastName !== undefined
                                    ? data?.lastName?.split('')[0]?.toUpperCase()
                                    : ''
                                }`}</span>
                              )}
                            </div>
                            <div className='d-flex justify-content-start flex-column'>
                              <span className='text-dark fw-bolder text-hover-primary fs-6'>
                                {`${data?.firstName} ${data?.lastName}`}
                              </span>
                              <span className='text-muted fw-bold text-muted d-block fs-7'>
                                {data?.email}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                            {data?.companyName}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                            {key?.whiteLabelSubdomain}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                            {data?.mobile}
                          </span>
                        </td>
                        <td>
                          <span className={`badge badge-light-${verfiyColor?.[data?.status]}`}>
                            {data?.status}
                          </span>
                        </td>
                        <td>
                          <span className={`badge badge-light-${StatusColor?.[data?.status2]}`}>
                            {data?.status2}
                          </span>
                        </td>

                        <td className='text-dark fw-bolder text-hover-primary  fs-6'>
                          {moment(data?.lastLogin).fromNow()}
                        </td>
                        <td>
                          {key?.lastMessageSend == null
                            ? '--'
                            : moment(key?.lastMessageSend?.createdAt).format('DD/MM/YYYY')}
                        </td>
                        <td>{data?.accountType}</td>
                        <td>
                          <a
                            href='#'
                            className='text-dark fw-bolder text-hover-primary d-block fs-6'
                          >
                            {moment(data?.createdAt).format('DD/MM/YYYY')}
                          </a>
                        </td>

                        <td>{key?.totalPurchased}</td>
                        <td>{key?.totalSpent}</td>
                        <td>{key?.totalMMS + key?.totalSMS}</td>

                        {(AuthenticateUser('delete-whitelabel') ||
                          AuthenticateUser('edit-whitelabel')) && (
                          <td className='text-end'>
                            <DropdownButton
                              // menuAlign='right'
                              title={<i className='bi bi-three-dots fs-5'></i>}
                              id='dropdown-menu-align-right'
                              variant='light'
                            >
                              <Dropdown.Item
                                onClick={() => {
                                  dispatch(ProfileDetailData(data?._id))
                                  navigate(`/user-profile`)
                                }}
                                className='menu-item p-3 '
                              >
                                Edit
                              </Dropdown.Item>

                              <Dropdown drop='start'>
                                <Dropdown.Toggle
                                  variant='light'
                                  id='dropdown-basic'
                                  className='menu-item p-3 bg-white fw-bold text-dark'
                                >
                                  <span className='menu-title'>
                                    status <i className='bi bi-chevron-right'></i>
                                  </span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      dispatch(
                                        UpdateStatus({
                                          userId: data?._id,
                                          status2: 'active',
                                        })
                                      )
                                    }}
                                  >
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                      <div
                                        className='rounded-circle'
                                        style={{
                                          width: '10px',
                                          height: '10px',
                                          backgroundColor: '#50cd89 ', // Red color
                                          marginRight: '10px',
                                        }}
                                      ></div>
                                      <span className='menu-title ' style={{width: '80px'}}>
                                        Active
                                      </span>
                                      {data?.status2 === 'active' && (
                                        <Check size={20} color='#198754' />
                                      )}
                                      {/* Green check mark */}
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      dispatch(
                                        UpdateStatus({
                                          userId: data?._id,
                                          status2: 'inactive',
                                        })
                                      )
                                    }}
                                  >
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                      <div
                                        className='rounded-circle'
                                        style={{
                                          width: '10px',
                                          height: '10px',
                                          backgroundColor: '#e4e6ef',
                                          marginRight: '10px',
                                        }}
                                      ></div>
                                      <span className='menu-title ' style={{width: '80px'}}>
                                        Inactive
                                      </span>
                                      {data?.status2 === 'inactive' && (
                                        <Check size={20} color='#198754' />
                                      )}
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      dispatch(
                                        UpdateStatus({
                                          userId: data?._id,
                                          status2: 'suspended',
                                        })
                                      )
                                    }}
                                  >
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                      <div
                                        className='rounded-circle'
                                        style={{
                                          width: '10px',
                                          height: '10px',
                                          backgroundColor: '#dc3545', // Red color
                                          marginRight: '10px',
                                        }}
                                      ></div>
                                      <span className='menu-title' style={{width: '80px'}}>
                                        Suspended
                                      </span>
                                      {data?.status2 === 'suspended' && (
                                        <Check size={20} color='#198754' />
                                      )}
                                    </div>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>

                              {AuthenticateUser('delete-whitelabel') && (
                                <Dropdown.Item
                                  data-kt-users-table-filter='delete_row'
                                  onClick={() => handleSelect(key?._id)}
                                  className='fw-bold p-3 text-danger'
                                >
                                  Delete
                                </Dropdown.Item>
                              )}
                            </DropdownButton>
                          </td>
                        )}
                      </tr>
                    )
                  })}
                  <tbody></tbody>
                </table>
              </div>
              <div className='abcd '>
                <select
                  className='SelectSize'
                  onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}
                >
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                  <option value={whiteLabelAccountList?.total}>ALL</option>
                </select>
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={whiteLabelAccountList?.totalPages}
                  onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                  containerClassName={'pagiantion'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          </>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default WhiteLabelList
